import NoticeBar from "./components/NoticeBar";
import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import EntranceBoard from "./components/EntranceBoard";
import AccessGuide from "./components/AccessGuide";
import IssueList from "./components/IssueList";
import CollectionSection from "./components/CollectionSection";
import UpdateLog from "./components/UpdateLog";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <NoticeBar />
      <SiteHeader />
      <main>
        <Hero />
        <EntranceBoard />
        <AccessGuide />
        <IssueList />
        <CollectionSection />
        <UpdateLog />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}